<template>
  <div class="md:mx-14 text-root-2 max-w-5xl mx-5">
    <div
      @click="$router.go(-1)"
      style="width: 65px"
      class="font-normal cursor-pointer flex justify-center items-center rounded-2xl border-text-root-3 text-root-1 mb-2"
    >
      <span class="text-xs"> <i class="el-icon-back text-sm"></i> Back</span>
    </div>
    <div class="grid mt-5 grid-cols-1 md:grid-cols-12 md:grid-rows-6 gap-10">
      <div
        class="user-card w-full flex row-span-6 flex-col bg-center px-6 py-6 md:py-10 justify-center col-span-6"
      >
        <div class="text-root-4 font-normal text-base">Available Balance</div>
        <div class="text-root-2 mt-2 mb-5 font-bold text-2xl">
          {{ parseMoney(totalBalance) }}
        </div>
        <div class="w-full border-t-text-root-3 pt-6">
          <div class="text-base font-normal mb-6">
            1. Enter withdrawal amount
          </div>
          <span
            class="font-normal text-xs mb-1 flex justify-between items-center"
            ><span> Enter Amount</span>
          </span>
          <el-form
            :model="withdrawalForm"
            ref="withdrawalForm"
            :rules="rules"
            size="normal"
          >
            <el-form-item class="w-full" prop="withdrawalAmount">
              <el-input
                prop="withdrawalAmount"
                class="text-xl"
                v-model="withdrawalForm.withdrawalAmount"
                name="amount"
                placeholder="$0.00"
              >
              </el-input>
            </el-form-item>
            <div class="w-full -mt-3 justify-end flex">
              <div
                @click="getTotalBalance"
                class="text-primary text-xs font-normal bg-orange-3 cursor-pointer rounded-lg mb-2 py-1 px-3"
              >
                Max Balance
              </div>
            </div>
          </el-form>
        </div>

        <div class="text-base font-normal mt-4 mb-6">
          2. Select Withdrawal Method
        </div>

        <el-radio-group
          class="flex flex-col mb-4"
          v-model="selectedWithdrawalMethod"
        >
          <el-radio
            @change="
              updateSelectedWithdrawalMethod(
                index,
                withdrawalMethod.id,
                withdrawalMethod.currency
              )
            "
            v-for="(withdrawalMethod, index) in withdrawalMethods"
            :key="index"
            :label="index"
            class="flex mb-4"
            :class="index === 0 ? '' : 'border-t-text-root-3 pt-4'"
          >
            <div class="-mt-0.5">
              <div
                class="font-medium flex items-center"
                :class="
                  index == selectedWithdrawalMethod
                    ? ' text-primary'
                    : 'text-root-2'
                "
              >
                <div
                  v-if="
                    withdrawalMethod.method === $transactionType.BANK_TRANSFER
                  "
                  class="ml-2 mr-4"
                >
                  <bank-icon />
                </div>
                <div
                  v-if="
                    withdrawalMethod.method === $transactionType.ASSET_TRANSFER
                  "
                  class="ml-1.5 mr-3.5"
                >
                  <usd-logo />
                </div>
                <div
                  :class="
                    index == selectedWithdrawalMethod
                      ? ' text-primary'
                      : 'text-root-2'
                  "
                  class="font-bold text-xs"
                >
                  {{
                    withdrawalMethod.method === $transactionType.BANK_TRANSFER
                      ? 'Bank Transfer (Wire Transfer)'
                      : withdrawalMethod.method ===
                        $transactionType.ASSET_TRANSFER
                      ? 'Asset Transfer (USDC)'
                      : ''
                  }}
                </div>
              </div>
              <div class="ml-10 text-xs font-normal text-root-4">
                <div
                  class="my-1"
                  v-if="
                    withdrawalMethod.method === $transactionType.BANK_TRANSFER
                  "
                >
                  Account Number :
                  <span>{{
                    withdrawalMethod.details.bankWithdrawalDetails.accountNumber
                  }}</span>
                </div>
                <div
                  class="my-1"
                  v-if="
                    withdrawalMethod.method === $transactionType.ASSET_TRANSFER
                  "
                >
                  Wallet:
                  <span style="max-width: 380px" class="max-w-sm break-words">
                    {{ withdrawalMethod.details.walletAddress }}
                  </span>
                </div>
                <p class="my-1">
                  Currency: <span>{{ withdrawalMethod.currency }}</span>
                </p>
              </div>
            </div>
          </el-radio>
        </el-radio-group>
        <div
          @click="showDialog = true"
          class="cursor-pointer text-base add-button font-normal hover:opacity-80 flex text-primary items-center justify-center py-2 mx-10"
        >
          + Add withdrawal Method
        </div>
      </div>
      <div class="user-card flex flex-col bg-center col-span-6 row-span-4 py-6">
        <div class="text-base pl-8 font-normal mt-4 mb-6">
          3. Review and Withdraw
        </div>

        <div class="flex px-8 border-t-text-root-3 py-4 justify-between">
          <div class="text-sm font-normal">Withdraw amount</div>
          <div
            class="flex items-center justify-center font-normal text-base text-root-4"
          >
            {{
              withdrawalForm.withdrawalAmount
                ? withdrawalForm.withdrawalAmount
                : '$0.00'
            }}
          </div>
        </div>
        <div class="flex px-8 py-4 justify-between">
          <div class="text-sm font-normal">Service charge</div>
          <div
            class="flex items-center justify-center font-normal text-base text-root-4"
          >
            $0.00
          </div>
        </div>
        <div class="flex px-8 py-4 justify-between">
          <div class="text-sm font-normal">Duration</div>
          <div
            class="flex items-center justify-center font-normal text-base text-root-4"
          >
            3-7 days
          </div>
        </div>
        <div class="flex px-8 py-4 justify-between">
          <div class="text-sm font-bold">To receive</div>
          <div
            class="flex items-center justify-center font-bold text-base text-root-4"
          >
            {{ withdrawalForm.withdrawalAmount }}
          </div>
        </div>
        <div class="px-8">
          <o-button
            :disabled="
              withdrawalMethods.length === 0 ||
              !formatAmount(withdrawalForm.withdrawalAmount) ||
              formatAmount(withdrawalForm.withdrawalAmount) >
                this.totalBalance ||
              selectedWithdrawalMethod === null
            "
            @click="validateForm('withdrawalForm')"
            >Next</o-button
          >
        </div>
      </div>
    </div>
    <withdrawal-method-dialog
      v-if="showDialog"
      :showDialog="showDialog"
      @closeDialog="closeDialog"
      @bankTransferWithdrawal="showDetailsDialog = true"
      @assetTransferWithdrawal="showAssetDetailsDialog = true"
    />
    <withdrawal-error-dialog
      v-if="showWithdrawalError"
      :showDialog="showWithdrawalError"
      @closeDialog="closeDialog"
      @contactSupport="goToSupport"
    />
    <bank-transfer-details-dialog
      v-if="showDetailsDialog"
      :showDialog="showDetailsDialog"
      @closeDialog="closeDialog"
      @verifyUser="verifyAuth('createWithdrawal')"
      @storeBankInfo="withdrawalInfo"
    />
    <asset-transfer-details-dialog
      v-if="showAssetDetailsDialog"
      :showDialog="showAssetDetailsDialog"
      @closeDialog="closeDialog"
      @verifyUser="verifyAuth('createWithdrawal')"
      @storeAssetInfo="withdrawalInfo"
    />
    <verify-auth-dialog
      :authState="withdrawalState"
      v-if="showVerifyAuthDialog"
      :showDialog="showVerifyAuthDialog"
      @closeDialog="closeDialog"
      @verifiedUser="addWithdrawal"
      @initiateWithdrawalRequest="initateWithdrawalRequest"
    />
  </div>
</template>

<script>
import { FormatAmount, ParseMoney } from '@/utils/helpers'
import reports from '@/mixins/getDashboardReports.js'
import getBalance from '@/mixins/getBalance.js'
import app from '@/mixins/app.js'

export default {
  name: 'Withdrawal',
  mixins: [getBalance, reports, app],
  data () {
    return {
      showDialog: false,
      showDetailsDialog: false,
      showWithdrawalError: false,
      showVerifyAuthDialog: false,
      showAssetDetailsDialog: false,
      withdrawalDetails: null,
      twoFaCode: null,
      withdrawalState: '',
      selectedWithdrawalMethod: null,
      withdrawalMethodId: null,
      withdrawalMethodCurrency: null,
      meta: null,
      radio: null,
      withdrawalForm: {
        withdrawalAmount: ''
      },
      rules: {
        withdrawalAmount: [
          { validator: this.validateAmount, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    validateAmount (rule, value, callback) {
      if (FormatAmount(value) > this.totalBalance) {
        callback(new Error("That's more than your balance"))
      } else if (!FormatAmount(value) || FormatAmount(value) < 1) {
        callback(new Error('Provide an amount'))
      } else {
        callback()
      }
    },
    validateForm (withdrawalForm) {
      this.$refs[withdrawalForm].validate((valid) => {
        if (valid) {
          this.verifyAuth('initiateWithdrawal')
        } else {
          this.$notify.error({
            title: 'Invalid input',
            message: 'Provide an amount',
            position: 'top-right'
          })
        }
      })
    },
    formatAmount (val) {
      return FormatAmount(val)
    },
    getTotalBalance () {
      this.withdrawalForm.withdrawalAmount = ParseMoney(this.totalBalance)
    },
    updateSelectedWithdrawalMethod (
      index,
      withdrawalMethodId,
      withdrawalMethodCurrency
    ) {
      this.withdrawalMethodId = withdrawalMethodId
      this.withdrawalMethodCurrency = withdrawalMethodCurrency
      this.selectedWithdrawalMethod = index
    },
    verifyAuth (withdrawalState) {
      this.showVerifyAuthDialog = true
      this.withdrawalState = withdrawalState
    },
    parseMoney (val) {
      return ParseMoney(val)
    },
    withdrawalInfo (withdrawalDetails) {
      this.withdrawalDetails = withdrawalDetails
    },
    async getDetails () {
      await this.getDashboardReports()
      await this.getWithdrawalMethods()
    },
    initateWithdrawalRequest (twoFaCode) {
      const vm = this
      const amount = FormatAmount(this.withdrawalForm.withdrawalAmount)

      const userData = {
        amount: amount,
        currency: this.withdrawalMethodCurrency,
        withdrawalMethodID: this.withdrawalMethodId,
        twoFaCode: twoFaCode.code
      }
      this.$store
        .dispatch('withdrawal/initiateWithdrawalRequest', { ...userData })
        .then(() => {
          this.showVerifyAuthDialog = false
          this.$swal({
            icon: 'success',
            title: 'Request Submitted',
            text: 'Withdrawal has been sent for approval, you will get notified once funds are disbursed',
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
          this.withdrawalForm.withdrawalAmount = ''
        })
        .catch((error) => {
          this.showVerifyAuthDialog = false
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$swal({
            icon: 'error',
            title: 'Oops',
            text: err,
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
        })
        .finally(() => {
          this.showVerifyAuthDialog = false
        })
    },
    addWithdrawal (twoFaCode) {
      if (this.withdrawalDetails.walletAddress) {
        this.meta = {
          twoFaCode: twoFaCode.code,
          type: '$transactionType.ASSET_TRANSFER',
          walletDetails: this.withdrawalDetails
        }
      } else {
        this.meta = {
          twoFaCode: twoFaCode.code,
          type: $transactionType.BANK_TRANSFER,
          bankDetails: this.withdrawalDetails.details,
          intermediaryBank: this.withdrawalDetails.intermediaryDetails
        }
      }
      const vm = this
      this.$store
        .dispatch('withdrawal/createWithdrawalMethod', { ...this.meta })
        .then(() => {
          this.showVerifyAuthDialog = false
          this.getWithdrawalMethods()
          this.$swal({
            icon: 'success',
            title: 'Account added',
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$swal({
            icon: 'error',
            title: 'Oops',
            text: err,
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
        })
        .finally(() => {
          this.showVerifyAuthDialog = false
        })
    },
    getWithdrawalMethods () {
      const vm = this
      this.$store
        .dispatch('withdrawal/getWithdrawalMethods')
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    },
    goToSupport () {
      window.open(
        this.tenantIsTorus
          ? 'mailto:hello@torusmara.com'
          : 'https://ovalfi.atlassian.net/servicedesk/customer/portal/'
      )
    },
    showErrorDialog () {
      this.showWithdrawalError = true
    },
    closeDialog () {
      this.showDialog = false
      this.showDetailsDialog = false
      this.showVerifyAuthDialog = false
      this.showWithdrawalError = false
      this.showAssetDetailsDialog = false
    }
  },
  components: {
    BankIcon: () => import('@/assets/icons/BankIcon.vue'),
    UsdLogo: () => import('@/assets/images/UsdcLogo.vue'),
    AssetTransferDetailsDialog: () =>
      import('@/components/withdraw/AssetTransferDetailsDialog.vue'),
    WithdrawalMethodDialog: () =>
      import('@/components/withdraw/WithdrawalMethodDialog.vue'),
    WithdrawalErrorDialog: () =>
      import('@/components/withdraw/WithdrawalErrorDialog.vue'),
    BankTransferDetailsDialog: () =>
      import('@/components/withdraw/BankTransferDetailsDialog.vue'),
    VerifyAuthDialog: () => import('@/components/auth/VerifyAuthDialog.vue')
  },
  computed: {
    withdrawalMethods () {
      return this.$store.state.withdrawal.withdrawalMethods || []
    }
  },
  async mounted () {
    await this.getDetails()
  },
  watch: {
    'withdrawalForm.withdrawalAmount': function (newValue) {
      const result = newValue
        .toString()
        .split('.')[0]
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        .replace(/^0+/g, '')
      this.$nextTick(() => {
        this.withdrawalForm.withdrawalAmount = newValue.toString().split('.')[1]
          ? ` $${result}.${newValue.toString().split('.')[1]}`
          : `$${result}`
      })
    },
    deep: true
  }
}
</script>

<style scoped>
.user-card {
  background: var(--background);
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}
.text-root-1 {
  color: var(--text-1);
}
.text-root-2 {
  color: var(--text-2);
}
.text-root-4 {
  color: var(--text-4);
}
.border-text-root-3 {
  border: 1px var(--text-1) solid;
}
.border-t-text-root-3 {
  border-top: 1px var(--text-3) solid;
}

>>> .el-input__inner:focus {
  border-color: #818799;
}
>>> .el-input__inner {
  background-color: var(--background);
  color: var(--text-1);
  height: 50px;
  border: 1px solid var(--text-3);
}
.add-button {
  background: var(--background);
  border: 1px solid var(--text-3);
  border-radius: 6px;
}
>>> .el-radio__input.is-checked .el-radio__inner {
  border-color: var(--color-primary);
  background: var(--color-primary) !;
}
</style>
